import { MemberAddress } from '@ace-clublabs/common-membership-api-types';
export interface IGetMemberHouseholdInfoRequest {
  guid: string;
}

export interface IGetMemberHouseholdInfoResponse {
  data: MemberAddress;
  error?: {
    message: string;
  };
}

export interface Member {
  firstName: string;
  lastName: string;
  gender: string;
  roleType: string;
  emailAddress?: string;
  roleCode?: string;
  phone?: Phone;
  customerId?: string;
  residenceAddress?: MemberAddress;
  mailingAddress?: MemberAddress;
  lodge?: string;
  birthDate?: string;
  title?: string;
  middleInitial?: string;
  suffix?: string;
}

export interface Phone {
  type: PhoneType;
  number: string;
  isDeclaredMobile: boolean;
  isMobileConsent?: boolean;
}

export interface MembershipPriceCartItem {
  title: string;
  amount: number;
  type: PriceCartItemType;
}

export enum PriceCartItemType {
  COST = 'COST',
  DISCOUNT = 'DISCOUNT',
}

export enum PhoneType {
  HOME = 'Home',
  MOBILE = 'Mobile',
}
